<template>
    <el-affix>
        <el-page-header :icon="ArrowLeft" @back="clickBackFunc" class="header-box">
            <template #title>
                <span class="text-large font-600 mr-3" > {{returnLabel}} </span>

            </template>
          <template #content>

            <el-button circle @click="clickchangeLange2" style="margin-left: 8px;" >
              <font-awesome-icon icon="fa-solid fa-language" />
            </el-button>
          </template>


            <template #extra>
<!--                <a :href="websiteUrl" target="_blank" v-if="null != companyObj.acccompanycode">-->
<!--                <el-button circle style="margin-right: 10px" >-->
<!--                    <font-awesome-icon icon="fa-solid fa-globe" />-->
<!--                </el-button>-->
<!--                </a>-->

                <el-badge
                    :value="chatInfoRef.msgCount"
                    :max="99"
                    v-show="useChatBtn != false && null != userInfoRef.login"
                    :hidden="chatInfoRef.msgCount === 0"
                    style="margin-right: 15px"
                >
<!--                 聊天按鈕
                    <el-button circle @click="clickChatFunc" >
                        <font-awesome-icon icon="fa-solid fa-comments" />
                    </el-button>-->
                </el-badge>
            </template>
        </el-page-header>

        <el-divider class="header-divider" />
    </el-affix>

  <languageSelect v-if="langSelectVisible2 == true" @save-complete="langSelectVisible2 = false" />
</template>

<script setup>
//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faComments, faGlobe,faLanguage } from '@fortawesome/free-solid-svg-icons'
import {ArrowLeft} from "@element-plus/icons-vue";
import {toRef, onBeforeMount, inject, ref, computed, getCurrentInstance} from "vue";
import {useChatinfo} from "@/stores/chatinfo";
import {useCompanyinfo} from "@/stores/companyinfo";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";
import LanguageSelect from "@/components/Shopopee3D/ui/languageSelect.vue";

library.add(faComments, faGlobe,faLanguage)

const props = defineProps(["returnLabel", "useChatBtn"])
const emits = defineEmits(["clickBackBtn", "clickChatBtn"])

const { proxy } = getCurrentInstance()

const chatInfoRef = toRef(useChatinfo())
const userInfoRef = toRef(useUserinfo())
//是否顯示語言選擇框
const langSelectVisible2 = ref(false)
//響應機制的companyinfo
// const companyInfoRef = toRef(useCompanyinfo())
//公司數據
// const companyObj = ref({})

// const { getCompanyObj } = inject('quotationMain', { getCompanyObj: () => { return companyInfoRef.value } })

function clickBackFunc(){
    emits("clickBackBtn")
}
function clickchangeLange2(){
  langSelectVisible2.value=true;
}

function clickChatFunc(){
    // emits("clickChatBtn")
    proxy.$router.push({name: "chat"})
}

// const websiteUrl = computed(() => {
//     return myUtil.generateEShopopeeShopUrl(companyObj.value.acccompanycode)
// })

onBeforeMount(() => {
    // companyObj.value = getCompanyObj()
})

</script>

<style scoped>
    .header-box {
        padding: 15px;
        background: #fefefe;
        box-sizing: border-box;
    }

    .header-divider {
        margin-bottom: 10px;
        margin-top: 0;
    }

    a:-webkit-any-link {
        color: unset;
        cursor: pointer;
        text-decoration: none;
    }

    a {
        color: unset;
        cursor: pointer;
        text-decoration: none;
    }
</style>